__webpack_require__.p = "https://sb-eventbadgescore.dev.itswebs.com/build/";